import { AfterContentInit, Component } from '@angular/core';
import { Config } from '../Config';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements AfterContentInit {

  public config = (window as any).config as Config;
  // fourTwelvePlanYearRange = '0';
  constructor() {

  }

  ngAfterContentInit() {
    // this.fourTwelvePlanYearRange = this.assemble4YearPlanRange();

    window.location.replace('https://www.pa.gov/agencies/penndot/projects-near-you.htm');
  }

  // assemble4YearPlanRange(): string {
  //  const currentDate = new Date();
  //  const currentYear = currentDate.getFullYear();
  //  const currentMonth = currentDate.getMonth() + 1;
  //  const isEvenYear = currentYear % 2 === 0;
  //  let range = '';

  //  // 4 Year Plan date range increments with Federal Fiscal Budget (Oct 1) on even years only.
  //  // Range then starts with the following (odd) year.
  //  // For example ... On Oct 1, 2016 the range will change from 2015-18 to 2017-20
  //  if (isEvenYear) {
  //    if (currentMonth >= 10) {
  //      range = `${currentYear + 1}-${String(currentYear + 4).substring(2)}`;
  //    } else {
  //      range = `${currentYear - 1}-${String(currentYear + 2).substring(2)}`;
  //    }
  //  } else {
  //    range = `${currentYear}-${String(currentYear + 3).substring(2)}`;
  //  }

  //  return range;
  // }

  // openSummaryRpt() {
  //  window.open(this.config.url + 'summary-report?reportType=progress&aoiType=state');
  // }

}
